import type { PlanVersionSummary } from '@/lib/apiTypes'

/** Total resources a plan touches (noop excluded). */
export function affectedCount(v: PlanVersionSummary): number {
  return v.add_count + v.change_count + v.destroy_count + v.replace_count
}

/** Distinct non-null plan_refs still present in history — "open" PR-scoped plans. */
export function openRefCount(versions: PlanVersionSummary[]): number {
  return new Set(versions.filter((v) => v.plan_ref).map((v) => v.plan_ref)).size
}

